<template>

  <div class="white-background-hack">
    <HomeDirect/>
  </div>
</template>

<script>
  import store from '../lib/store';
  import settings from '../settings/degarde';
  import HomeDirect from '../pages/HomeDirect';


  export default {
    name: 'Degarde',
    components: {
      HomeDirect,
    },
    created() {
      store.set('brewery', settings.brewery);
      store.set('info_url', settings.info_url);
      store.set('title_in_progress', settings.title.in_progress);
      store.set('title_success', settings.title.success);
      store.set('title_subtext', settings.title.subtext);
      store.set('review_summary', settings.review.summary);
      store.set('review_button_text', settings.review.button_text);
    },
  };

</script>

<style>
  .white-background-hack {
    background-color: #eeeeee;
    background-image: none;
    min-height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// Degarde.vue?285aa472